/* eslint-disable max-len */
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { type FinderVehicleManagementModuleSpecsFragment } from '../../../../api/fragments/FinderVehicleManagementModuleSpecs';
import CascaderField from '../../../../components/fields/CascaderField';
import InputField from '../../../../components/fields/InputField';
import PasswordField from '../../../../components/fields/PasswordField';
import SwitchField from '../../../../components/fields/SwitchField';
import useSystemSwitchData from '../../../../utilities/useSystemSwitchData';
import useModuleOptions from '../modules/implementations/shared/useModuleOptions';

const StyledContainer = styled(Row)`
    background-color: #fff;
    padding: 20px;
`;

type FinderVehicleManagementModuleDetailsFormProps = {
    module: FinderVehicleManagementModuleSpecsFragment;
};

const FinderVehicleManagementModuleDetailsForm = ({ module }: FinderVehicleManagementModuleDetailsFormProps) => {
    const { t } = useTranslation(['moduleDetails']);

    const { yesNoSwitch } = useSystemSwitchData();

    const isSingapore = module.company.countryCode === 'SG';

    const options = useModuleOptions(module.company, { addNoneOptions: { autoplay: true } });

    return (
        <StyledContainer gutter={10}>
            {isSingapore && (
                <Col md={8} xs={24}>
                    <SwitchField
                        {...yesNoSwitch}
                        {...t('moduleDetails:fields.allowLTA', { returnObjects: true })}
                        name="allowLTA"
                    />
                </Col>
            )}
            <Col md={8} xs={24}>
                <InputField {...t('moduleDetails:fields.apiKey', { returnObjects: true })} name="secrets.apiKey" />
            </Col>
            <Col md={8} xs={24}>
                <PasswordField
                    {...t('moduleDetails:fields.secretKey', { returnObjects: true })}
                    name="secrets.secretKey"
                    forAdmin
                />
            </Col>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.loginEndpoint', { returnObjects: true })}
                    name="secrets.loginEndpoint"
                />
            </Col>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.apiEndpoint', { returnObjects: true })}
                    name="secrets.apiEndpoint"
                />
            </Col>
            <Col md={8} xs={24}>
                <InputField
                    {...t('moduleDetails:fields.finderUrl', { returnObjects: true })}
                    name="secrets.finderUrl"
                />
            </Col>
            <Col md={8} xs={24}>
                <CascaderField
                    {...t('moduleDetails:fields.autoplayModuleId', {
                        returnObjects: true,
                    })}
                    name="autoplaySettingId"
                    options={options.autoplay}
                    showSearch
                />
            </Col>
        </StyledContainer>
    );
};

export default FinderVehicleManagementModuleDetailsForm;
